module.exports = __webpack_public_path__ + "static/0ab71010abeae948bd82477e1b2463eea9b309fa6a54d51f78ff0968a8c2a97f-0edd2489aada88107ea7bedfa2639411.png";